/**
 * interactions.js — Regle pure "prochaine action obligatoire" (SPEC-05).
 *
 * Isolee de storage.js pour rester testable sans localStorage (window
 * indisponible sous `node --test`), meme discipline que reassort.js/scoring.js.
 *
 * Regle : un prospect ne peut pas se retrouver sans prochaineAction dont la
 * date est dans le futur. hasFutureProchaineAction() est la verite unique,
 * utilisee a la fois pour bloquer l'enregistrement (storage.js) et pour
 * lister les prospects a corriger (carte Dashboard).
 */

export function hasFutureProchaineAction(prospect, now = new Date()) {
  const date = prospect?.prochaineAction?.date;
  if (!date) return false;
  const t = new Date(date).getTime();
  if (Number.isNaN(t)) return false;
  return t > now.getTime();
}

/**
 * Resout la prochaineAction a retenir pour un enregistrement d'interaction.
 * - Si le formulaire en fournit une (date valide) : elle remplace toujours
 *   celle du prospect (nouvel engagement plus recent).
 * - Sinon : si le prospect a deja une prochaineAction future, on la garde
 *   inchangee (return null = "ne pas ecraser").
 * - Sinon (ni fournie, ni existante future) : blocage, l'appelant ne doit
 *   pas enregistrer l'interaction.
 */
export function resolveProchaineAction(prospect, input, now = new Date()) {
  const fournie = input && input.date && !Number.isNaN(new Date(input.date).getTime())
    ? { date: input.date, libelle: input.libelle || '' }
    : null;

  if (fournie) return { ok: true, prochaineAction: fournie, updateProspect: true };
  if (hasFutureProchaineAction(prospect, now)) return { ok: true, prochaineAction: null, updateProspect: false };
  return { ok: false, prochaineAction: null, updateProspect: false };
}
